import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import { useMediaQuery, makeStyles } from '@material-ui/core';
import { SlideUpTransition } from '../Transitions/Transitions';
import CloseIcon from '../CustomIcons/CloseIcon';
import { PagaGanaCampaignTermsLink } from '../../Configs/Links';

import BANNERS_CONFIRMACION_PSE_BANNER_PENDING_CONFIRMATION from '../../Assets/images/efg/banner_pse_banner_pendiente_confirmacion.jpg';

const PagaGanaDialog = props => {
  const { onClose, open = true } = props;
  const classes = useStyles();
  const isMobileSize = useMediaQuery(theme => theme.breakpoints.down('sm'));

  const content = BANNERS_CONFIRMACION_PSE_BANNER_PENDING_CONFIRMATION;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      fullWidth
      TransitionComponent={isMobileSize ? SlideUpTransition : undefined}
      PaperProps={{
        className: classes.paper
      }}
    >
      <IconButton
        aria-label="cerrar diálogo"
        onClick={onClose}
        className={classes.closeButton}
      >
        <CloseIcon />
      </IconButton>
      <div className={classes.imageContainer}>
        <img
          width="100%"
          alt="Paga y Gana"
          src={content}
          className={classes.image}
        />
        <div className={classes.textContainer}>
          <p className={classes.text}>
            Sigue pagando por PSE para que tengas más oportunidades de ganar
            hasta $50.000 de descuento en tu próxima factura. Para más
            información consulta los términos y condiciones:{' '}
            <a
              href={PagaGanaCampaignTermsLink}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.textLink}
            >
              aquí
            </a>
            .
          </p>
        </div>
      </div>
    </Dialog>
  );
};

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: theme.custom.borderRadius || 8,
    width: '630px'
  },
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    zIndex: 1
  },
  imageContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
  },
  image: {
    objectFit: 'cover',
    display: 'block',
    maxHeight: '70%'
  },
  textContainer: {
    padding: '5px 30px 20px 30px',
    backgroundColor: '#f9f9f9',
    color: '#333',
    textAlign: 'center',
    fontSize: '14px',
    lineHeight: '1.5'
  },
  text: { lineHeight: '15px', fontSize: '11px', marginTop: '20px' },
  textLink: { color: '#007bff', textDecoration: 'underline' }
}));

export default PagaGanaDialog;
